import React from 'react'
// SHEDDWEB-812: Hide IL resident button we're not sure what the feature is used for and it confuses users
// import React, { useContext } from 'react'
// import { TicketsAppContext } from '../context/tickets-app-context'
// import PartyDialog from './party-dialog'
// import { hasOnlyChicagoTickets } from '../helpers/logic'

const ILLINOIS_FREE_DAY_NAME = 'Illinois Resident Free Day'

function Alert({ alert }) {
  const { name, description } = alert
  // SHEDDWEB-812: Hide IL resident button we're not sure what the feature is used for and it confuses users
  // const { fromEvent, chosenEvent } = useContext(TicketsAppContext)
  // let illinoisFreeDay = false
  // const chicagoTicketsExist =
  //   chosenEvent && hasOnlyChicagoTickets(chosenEvent.tickets)

  if (name === ILLINOIS_FREE_DAY_NAME) {
    // illinoisFreeDay = true
  }
  return (
    <div
      role="alert"
      className="yellow-bordered-content"
    >
      <h4>{name}</h4>
      <p
        dangerouslySetInnerHTML={{
          __html: description.replace(/<p>/g, '<p class="mb-0">')
        }}
      >
        {}
      </p>
      {/*SHEDDWEB-812: Hide IL resident button we're not sure what the feature is used for and it confuses users*/}
      {/*{fromEvent &&*/}
      {/*  chosenEvent &&*/}
      {/*  illinoisFreeDay &&*/}
      {/*  !chicagoTicketsExist && (*/}
      {/*    <PartyDialog*/}
      {/*      buttonTitle="Add Illinois Residents"*/}
      {/*      buttonClassName="button -dark -big flex mt-16"*/}
      {/*      illinoisChecked*/}
      {/*    />*/}
      {/*  )}*/}
    </div>
  )
}

export default Alert
